import urlUtil from 'url'

import { normalizeUrl } from 'shared/utils/url'

export const getPaginationUrl = (url, pageNumber) => {
  if (!url) {
    return null
  }

  const { query = '', pathname = '', ...rest } = urlUtil.parse(url)

  const searchParams = new URLSearchParams(query || '')

  if (!pageNumber || String(pageNumber) === '1') {
    searchParams.delete('pageNumber')
  } else {
    searchParams.set('pageNumber', pageNumber)
  }

  const formatData = {
    pathname,
    ...rest,
    search: searchParams.toString(),
  }

  const modifiedUrl = urlUtil.format(formatData)

  return normalizeUrl(modifiedUrl)
}
